import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './testimonial17.css'

const Testimonial17 = (props) => {
  return (
    <div className="thq-section-padding">
      <div className="testimonial17-max-width thq-section-max-width">
        <div className="testimonial17-container10"></div>
        <div className="thq-grid-2">
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card1"
              >
                <div className="testimonial17-container12">
                  <img
                    alt={props.author1Alt}
                    src="/team/picture%2011-200h.png"
                    className="testimonial17-image1"
                  />
                  <div className="testimonial17-container13">
                    <strong>
                      {props.author1Name ?? (
                        <Fragment>
                          <strong className="testimonial17-text22 thq-body-large">
                            <span>The Rt Hon Patricia Scotland KC</span>
                            <br></br>
                          </strong>
                        </Fragment>
                      )}
                    </strong>
                    <span>
                      {props.author1Position ?? (
                        <Fragment>
                          <span className="testimonial17-text27 thq-body-small">
                            Secretary General
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span>
                  {props.review1 ?? (
                    <Fragment>
                      <span className="testimonial17-text28 thq-body-small" style={{ textAlign: 'justify', display: 'block' }}>
                        Our focus on AI for good is not a passing phase; it is
                        our pathway to inclusive growth, sustainable
                        development, and shared prosperity for all our member
                        countries. Our commitment to empowering women with
                        digital skills is not casual; it is an imperative.
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card2"
              >
                <div className="testimonial17-container14">
                  <img
                    alt={props.author2Alt}
                    src="https://www.intracen.org/sites/default/files/styles/large/public/media/image/media_image/2022/09/07/abdoulie_jammeh.jpg?itok=ljmXv1AO"
                    className="testimonial17-image2"
                  />
                  <div className="testimonial17-container15">
                    <strong>
                      {props.author2Name ?? (
                        <Fragment>
                          <strong className="testimonial17-text29 thq-body-large">
                            Abdoulie Jammeh 
                          </strong>
                        </Fragment>
                      )}
                    </strong>
                    <span>
                      {props.author2Position ?? (
                        <Fragment>
                          <span className="testimonial17-text25 thq-body-small" style={{ textAlign: 'justify', display: 'block' }}>
                          Deputy Permanent Secretary, Ministry of Trade, Industry, Regional Integration, and Employment, The Gambia
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span>
                  {props.review2 ?? (
                    <Fragment>
                      <span className="testimonial17-text26 thq-body-small" style={{ textAlign: 'justify', display: 'block' }}>
                      As lead for the Working Group on Research and Innovation for the CAIC this represents a critical milestone for The Gambia. We are deeply thankful to the Commonwealth for facilitating this program, which is instrumental in building our national capacity in AI and related technologies.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card3"
              >
                <div className="testimonial17-container16">
                  <img
                    alt={props.author3Alt}
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Paula_Ingabire_%28cropped%29.jpg/330px-Paula_Ingabire_%28cropped%29.jpg"
                    className="testimonial17-image3"
                  />
                  <div className="testimonial17-container17">
                    <strong>
                      {props.author3Name ?? (
                        <Fragment>
                          <strong className="testimonial17-text35 thq-body-large">
                          Hon. Paula Ingabire
                          </strong>
                        </Fragment>
                      )}
                    </strong>
                    <span>
                      {props.author3Position ?? (
                        <Fragment>
                          <span className="testimonial17-text31 thq-body-small">
                          Minister of ICT and Innovation, Rwanda
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span>
                  {props.review3 ?? (
                    <Fragment>
                      <span className="testimonial17-text34 thq-body-small" style={{ textAlign: 'justify', display: 'block' }} >
                        Rwanda seeks to become Africa's AI research hub and
                        welcomes the private sector and academia to work with us
                        to co-design AI-enabled solutions that will accelerate
                        the continent's social-economic development.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card4"
              >
                <div className="testimonial17-container18">
                  <img
                    alt={props.author4Alt}
                    src="\team\picture 3-1400w.png"
                    className="testimonial17-image4"
                  />
                  <div className="testimonial17-container19">
                    <strong>
                      {props.author4Name ?? (
                        <Fragment>
                          <strong className="testimonial17-text33 thq-body-large">
                            Suresh Yadav
                          </strong>
                        </Fragment>
                      )}
                    </strong>
                    <span>
                      {props.author4Position ?? (
                        <Fragment>
                          <span className="testimonial17-text32 thq-body-small" style={{ textAlign: 'justify', display: 'block' }}>
                            Secretary, Commonwealth Artificial Intelligence Consortium
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span>
                  {props.review4 ?? (
                    <Fragment>
                      <span className="testimonial17-text30 thq-body-small" style={{ textAlign: 'justify', display: 'block' }}>
                      Artificial Intelligence holds the potential to be a great equalizer in our society. By leveraging AI, we can bridge the digital divide and ensure that everyone, regardless of their background, has access to the tools and opportunities needed to thrive in the digital age. Our mission is to harness the power of AI to create a more inclusive and equitable world, where technology serves as a bridge, not a barrier. Democratising access to AI will be our key priority in the work of CAIC.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card5"
              >
                <div className="testimonial17-container20">
                  <img
                    alt={props.author5Alt}
                    src="\team\picture 4-1400w.jpg"
                    className="testimonial17-image5"
                  />
                  <div className="testimonial17-container21">
                    <strong>
                      {props.author5Name ?? (
                        <Fragment>
                          <strong className="testimonial17-text36 thq-body-large">
                            Dr. Radika Kumar
                          </strong>
                        </Fragment>
                      )}
                    </strong>
                    <span>
                      {props.author5Position ?? (
                        <Fragment>
                          <span className="testimonial17-text37 thq-body-small">
                            Adviser, Artificial Intelligence & Transformative Technology 
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span>
                  {props.review5 ?? (
                    <Fragment>
                      <span className="testimonial17-text38 thq-body-small" style={{ textAlign: 'justify', display: 'block' }}>
                      There is an estimate that AI is estimated to add US$15.7 trillion to the world economy to 2030. It is therefore critical that young people in Commonwealth countries are not only empowered to use AI, but that they are also equipped with the skills to shape and benefit from it.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card6"
              >
                <div className="testimonial17-container22">
                  <img
                    alt={props.author6Alt}
                    src="https://www.csiro.au/-/media/WordPress/Algorithm/DJT7003-Sinergija-2019-002-1024x683.jpg?mw=800&amp;hash=26427479B42843C4B7447B27B0FBFE77"
                    className="testimonial17-image6"
                  />
                  <div className="testimonial17-container23">
                    <strong>
                      {props.author6Name ?? (
                        <Fragment>
                          <strong className="testimonial17-text39 thq-body-large">
                            Stela Solar
                          </strong>
                        </Fragment>
                      )}
                    </strong>
                    <span>
                      {props.author6Position ?? (
                        <Fragment>
                          <span className="testimonial17-text40 thq-body-small">
                          Director of Australia's National AI Centre
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span>
                  {props.review6 ?? (
                    <Fragment>
                      <span className="testimonial17-text41 thq-body-small" style={{ textAlign: 'justify', display: 'block' }}>
                      AI technologies are fast becoming integrated into the
                        products and services we use at work, in life, and
                        through education. Considering the scale of the
                        AI-driven transformation, it's important that our
                        diverse voices across the Commonwealth community shape
                        how AI is created, and benefit from the advancements and
                        opportunities which are emerging.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card7"
              >
                <div className="testimonial17-container24">
                  <img
                    alt={props.author7Alt}
                    src="https://th.bing.com/th/id/R.0dacd178eb71fd025b1e29d2f13f6798?rik=Tm9B4mphkE0ECg&amp;pid=ImgRaw&amp;r=0"
                    className="testimonial17-image7"
                  />
                  <div className="testimonial17-container25">
                    <strong>
                      {props.author7Name ?? (
                        <Fragment>
                          <strong className="testimonial17-text42 thq-body-large">
                          Keith Strier
                          </strong>
                        </Fragment>
                      )}
                    </strong>
                    <span>
                      {props.author7Position ?? (
                        <Fragment>
                          <span className="testimonial17-text43 thq-body-small">
                          Former  Vice President of NVIDIA for Worldwide AI
                          Initiatives
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span>
                  {props.review7 ?? (
                    <Fragment>
                      <span className="testimonial17-text44 thq-body-small" style={{ textAlign: 'justify', display: 'block' }}>

                        NVIDIA's collaboration with the Commonwealth and its
                        partners will further democratize the benefits of AI,
                        closing the resource divide through a combination of
                        accelerated computing, cloud and start-ups to empower
                        the smallest and most vulnerable nations to mitigate the
                        impact of climate change, upskill workforces, and
                        improve access to public services.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Testimonial17.defaultProps = {
  author1Name: undefined,
  author2Position: undefined,
  review2: undefined,
  author1Position: undefined,
  author2Alt: 'image',
  review1: undefined,
  author2Name: undefined,
  author3Alt: 'image',
  review4: undefined,
  author3Position: undefined,
  author4Position: undefined,
  author4Name: undefined,
  author1Alt: 'image',
  review3: undefined,
  author4Alt: 'image',
  author3Name: undefined,
  author5Alt: 'image',
  author6Alt: 'image',
  author5Name: undefined,
  author6Name: undefined,
  author5Position: undefined,
  author6Position: undefined,
  review5: undefined,
  review6: undefined,
  author7Alt: 'image',
  author7Name: undefined,
  author7Position: undefined,
  review7: undefined,
}

Testimonial17.propTypes = {
  author1Name: PropTypes.element,
  author2Position: PropTypes.element,
  review2: PropTypes.element,
  author1Position: PropTypes.element,
  author2Alt: PropTypes.string,
  review1: PropTypes.element,
  author2Name: PropTypes.element,
  author3Alt: PropTypes.string,
  review4: PropTypes.element,
  author3Position: PropTypes.element,
  author4Position: PropTypes.element,
  author4Name: PropTypes.element,
  author1Alt: PropTypes.string,
  review3: PropTypes.element,
  author4Alt: PropTypes.string,
  author3Name: PropTypes.element,
  author5Alt: PropTypes.string,
  author6Alt: PropTypes.string,
  author5Name: PropTypes.element,
  author6Name: PropTypes.element,
  author5Position: PropTypes.element,
  author6Position: PropTypes.element,
  review5: PropTypes.element,
  review6: PropTypes.element,
  author7Alt: PropTypes.string,
  author7Name: PropTypes.element,
  author7Position: PropTypes.element,
  review7: PropTypes.element,
}

export default Testimonial17
